import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-down-black.svg'


const _hoisted_1 = {
  key: 0,
  class: "pb-2"
}
const _hoisted_2 = { class: "text-sm font-medium text-gray-lp-300" }
const _hoisted_3 = { class: "text-gray-600 text-xs" }
const _hoisted_4 = {
  key: 1,
  class: "text-base font-semibold"
}
const _hoisted_5 = { class: "space-y-1 px-4" }
const _hoisted_6 = {
  key: 0,
  class: "pb-4"
}
const _hoisted_7 = { class: "text-sm font-medium text-gray-lp-300" }
const _hoisted_8 = { class: "text-gray-600 text-xs" }
const _hoisted_9 = {
  key: 0,
  class: "text-gray-700 mb-2"
}
const _hoisted_10 = { class: "grid grid-cols-3 gap-4" }
const _hoisted_11 = /*#__PURE__*/_createVNode("p", { class: "font-medium" }, "DEL", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { class: "font-medium" }, "DEX", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("p", { class: "font-medium" }, "CODREJ", -1)
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "text-gray-700 text-sm mb-2" }
const _hoisted_16 = { class: "text-base" }
const _hoisted_17 = { class: "border-t px-4 pt-2 mt-4 flex justify-center items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalDexAssessment = _resolveComponent("ModalDexAssessment")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: 
      `${
        _ctx.isCollapsed ? '' : 'pb-2'
      } pt-2 bg-white rounded-lg shadow border border-gray-lp-1400 mt-2`
    
    }, [
      _createVNode("div", {
        class: 
        `${
          _ctx.isCollapsed ? '' : 'mb-4'
        } pb-2 flex items-center justify-between border-b px-4`
      
      }, [
        (_ctx.isSummary)
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode("h3", _hoisted_2, _toDisplayString(_ctx.detailData.lastStatus) + _toDisplayString(_ctx.detailData.rejectReason ? " - " + _ctx.detailData.rejectReason : ""), 1),
              _createVNode("p", _hoisted_3, _toDisplayString(_ctx.lastStatusAt) + " " + _toDisplayString(_ctx.detailData.lastDelivPartnerName
              ? " - " + _ctx.detailData.lastDelivPartnerName
              : ""), 1)
            ]))
          : (_openBlock(), _createBlock("h2", _hoisted_4, _toDisplayString(_ctx.$t("pusatResolusi.deldex.summary")) + " DEX/CODREJ/DEL ", 1)),
        _createVNode("button", {
          class: "p-2 hover:bg-gray-100 rounded-full",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleCollapse && _ctx.toggleCollapse(...args)))
        }, [
          _createVNode("img", {
            src: _imports_0,
            class: ["w-6 h-6 transition-transform duration-200", { 'transform rotate-180': !_ctx.isCollapsed }],
            alt: "chevron"
          }, null, 2)
        ])
      ], 2),
      _withDirectives(_createVNode("div", _hoisted_5, [
        (!_ctx.isSummary)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode("h3", _hoisted_7, _toDisplayString(_ctx.detailData.lastStatus) + _toDisplayString(_ctx.detailData.rejectReason ? " - " + _ctx.detailData.rejectReason : ""), 1),
              _createVNode("p", _hoisted_8, _toDisplayString(_ctx.lastStatusAt) + " " + _toDisplayString(_ctx.detailData.lastDelivPartnerName
              ? " - " + _ctx.detailData.lastDelivPartnerName
              : ""), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", {
          class: `${_ctx.isSummary ? '' : 'pb-4'} text-sm`
        }, [
          (!_ctx.isSummary)
            ? (_openBlock(), _createBlock("h4", _hoisted_9, "Percobaan"))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_10, [
            _createVNode("div", null, [
              _hoisted_11,
              _createVNode("p", null, _toDisplayString(_ctx.formatAttempt(_ctx.detailData.delAttemps)), 1)
            ]),
            _createVNode("div", null, [
              _hoisted_12,
              _createVNode("p", null, _toDisplayString(_ctx.formatAttempt(_ctx.detailData.dexAttemps)), 1)
            ]),
            _createVNode("div", null, [
              _hoisted_13,
              _createVNode("p", null, _toDisplayString(_ctx.formatAttempt(_ctx.detailData.codRejAttemps)), 1)
            ])
          ])
        ], 2),
        (!_ctx.isSummary)
          ? (_openBlock(), _createBlock("div", _hoisted_14, [
              _createVNode("h4", _hoisted_15, _toDisplayString(_ctx.$t("pusatResolusi.deldex.lastCourier")), 1),
              _createVNode("p", _hoisted_16, _toDisplayString(_ctx.detailData.courierName || "-"), 1)
            ]))
          : _createCommentVNode("", true)
      ], 512), [
        [_vShow, !_ctx.isCollapsed]
      ]),
      _withDirectives(_createVNode("div", _hoisted_17, [
        _createVNode("button", {
          class: "text-red-lp-100 font-semibold underline text-14px",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleShowDexModal && _ctx.handleShowDexModal(...args)))
        }, _toDisplayString(_ctx.$t("pusatResolusi.deldex.detailDex")), 1)
      ], 512), [
        [_vShow, !_ctx.isCollapsed]
      ])
    ], 2),
    _createVNode(_component_ModalDexAssessment, {
      modelValue: _ctx.showModalDex,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModalDex = $event)),
      dexData: _ctx.dexAssessmentData
    }, null, 8, ["modelValue", "dexData"])
  ], 64))
}